import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2da118ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "powered-by"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Powered by", -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "powered-by"
}
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", null, [
    (!_ctx.partnerSlug || _ctx.logoError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("img", {
            src: _ctx.asset(require(`@/assets/openbay-logo.svg`)),
            alt: "Openbay Logo"
          }, null, 8, _hoisted_3)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("img", {
            src: `/assets/partners/${_ctx.partnerSlug}/logo.svg`,
            alt: "Openbay Logo"
          }, null, 8, _hoisted_5)
        ]))
  ]))
}